import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  plans: [],
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  savePlan: ['plan', 'onSuccess', 'onError'],
  removePlan: ['plan', 'onSuccess', 'onError'],
  planError: ['error']
})

const savePlan = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removePlan = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const planError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.PLAN_ERROR]: planError,

  [Types.SAVE_PLAN]: savePlan,
  [Types.REMOVE_PLAN]: removePlan,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as PlanTypes,
  Creators as PlanActions
}
